import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  max-height: 470px;
  height: 100%;
  overflow-y: auto;
  border-radius: 8px;
  width: 100%;
  background-color: #fff;
  border: ${({ theme }) => `1px solid ${theme.colors.border}`};
`;

export const Card = styled.section<{$isSoldOff: boolean}>`
  color: ${({ theme }) => theme.colors.text.primary};
  background-color: #fff;
  width: 90%;
  padding: 24px;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.border}`};
  font-size: 16px;
  font-weight: 600;
  cursor: ${({ $isSoldOff }) => $isSoldOff ? 'not-allowed' : 'pointer'};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  
  & .top-side-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    & button {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      line-height: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 16px;
      background-color: ${({ theme }) => theme.colors.surface.low};

      &:disabled {
        background-color: ${({ theme }) => theme.colors.button.surface.disabled};
      }
    }
  }

  & small {
    font-size: 12px;
    color: #637381;
    font-family: Inter;
    font-weight: 400;
  }
`;
